import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="hero">
      <div className="hero-content">
        <div className={`hero-title ${isLoaded ? 'fade-in' : ''}`}>
          <h1 className="portfolio-title">
            <span className="portfolio-name">Kristijana's</span>
            <span className="portfolio-text">PORTFOLIO</span>
          </h1>
        </div>
        
        <div className={`hero-image-container ${isLoaded ? 'scale-in' : ''}`}>
          <img 
            src="/KRISTIJANA-PIC.JPG" 
            alt="Kristijana" 
            className="hero-image"
          />
        </div>

        <div className="scroll-indicator">
          <div className="scroll-line"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;